import { render, staticRenderFns } from "./UserTableBody.vue?vue&type=template&id=68a9f072&"
import script from "./UserTableBody.vue?vue&type=script&lang=js&"
export * from "./UserTableBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports